module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('textarea', {
    ref: "codeEditor"
  })
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-e4cfd89c","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/WebEditor/index.vue
// module id = 529
// module chunks = 1